// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

import * as filters from './utility/filter';
import Ajax from './utility/ajax';
import Utils from './utility/utils';
import ApiList from './utility/api';
import cache from './utility/cache';
import {message} from './utility/resetMessage';
import store from './store/index'
import Lodash from 'lodash'
import EyDialog from './components/dialog/index'
import verifyButton from './components/VerifyButton'
import 'element-ui/lib/theme-chalk/index.css'
import './style/public.scss'
import echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.prototype.$echarts = echarts
Vue.prototype.ajax = Ajax;
Vue.prototype.$Utils = Utils;
Vue.prototype.apis = ApiList;
Vue.prototype.store = store;
Vue.prototype.Cache = cache;
Vue.prototype._ = Lodash;
Vue.component(EyDialog.name, EyDialog)
Vue.component(verifyButton.name, verifyButton)
Vue.use(ElementUI)
Vue.prototype.$message = message;
ApiList.public.getConfigFn()
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js